export default "/static/media/vodafone.24c1c844.svg";